import {
    GET_USUARIO_DETALLES, ADD_NEW_USUARIO, ADD_CENTRO_USUARIO, 
    DELETE_CENTRO_USUARIO, MODIFY_CENTRO_USUARIO

} from '../constants/action_types';

const initialState = { usuarioCentros: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_USUARIO_DETALLES:

            return {
                usuarioCentros: [],
                isLoading: true
            };

        case GET_USUARIO_DETALLES + "_SUCCESS":

            return {
                usuarioCentros: action.payload.data.usuarioCentro,
                isLoading: false
            };

        case ADD_CENTRO_USUARIO:

            const newArr = [...state.usuarioCentros, action.payload]

            return {
                usuarioCentros: newArr,
                isLoading: false
            };

        case MODIFY_CENTRO_USUARIO:
            return {
                usuarioCentros: state.usuarioCentros.map((centro) => {
                    if (centro.id !== action.payload.id) return centro;
                    else return action.payload;
                }),
                isLoading: false
            };

        case DELETE_CENTRO_USUARIO:
            return {
                usuarioCentros: state.usuarioCentros.filter(centro => centro.id !== action.payload.id),
                isLoading: false
            };

        case ADD_NEW_USUARIO:
            
            return initialState;

        default:

            return state;
    }

}